import React, { forwardRef, useRef } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '../Typography';
import ErrorIcon from '../../../assets/Error.svg';
import './TextInput.css';

const computeInputClassName = (inputClassName, disabled, error) => {
  const classes = [inputClassName];

  if (disabled) {
    classes.push('text-input--disabled');
  }

  if (error) {
    classes.push('text-input--error');
  }

  return classes.join(' ');
};

export const TextInput = forwardRef(({
  id,
  type,
  onChange,
  displayLabel,
  wrapperClassName,
  labelClassName,
  inputClassName,
  name,
  placeholder,
  required,
  disabled,
  error,
}, ref) => {
  const unusedRef = useRef();
  const inputRef = ref || unusedRef;
  const computedLabel = required ? `${displayLabel}*` : displayLabel;
  const computedInputClassName = computeInputClassName(inputClassName, disabled, error);

  return (
    <div className={wrapperClassName}>
      <label
        htmlFor={name}
        className={labelClassName}
      >
        {computedLabel}
      </label>
      <div className="text-input-inner-wrapper">
        <input
          data-testid="testid-TextInput"
          id={id}
          ref={inputRef}
          onChange={onChange}
          type={type}
          name={name}
          className={computedInputClassName}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
        />
        {error && (
          <div className="error-icon">
            <img alt="" src={ErrorIcon} />
          </div>
        )}
      </div>
      {error && (
        <div className="text-input-error-message">
          <Typography className="error-text">
            {error}
          </Typography>
        </div>
      )}
    </div>
  );
});

TextInput.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string,
  onChange: PropTypes.func,
  displayLabel: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  wrapperClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
};

TextInput.defaultProps = {
  type: 'text',
  onChange: () => { },
  wrapperClassName: 'text-input-wrapper',
  labelClassName: 'text-input-label',
  inputClassName: 'text-input',
  placeholder: '',
  required: false,
  disabled: false,
  error: '',
};
